import "./index.esm.5c7d6d23.js";
import "./cv-builder.0461d822.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6be7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6be7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eZ0we", function(module, exports) {

$parcel$export(module.exports, "PAGE_LANG", () => $ae872a3a7edb7f6b$export$115162aea5a8ed44);
$parcel$export(module.exports, "UI_LOCALE", () => $ae872a3a7edb7f6b$export$7d2f96c91533b722);
$parcel$export(module.exports, "registerTranslations", () => $ae872a3a7edb7f6b$export$595d4929f5276beb);
$parcel$export(module.exports, "t", () => $ae872a3a7edb7f6b$export$625550452a3fa3ec);
$parcel$export(module.exports, "langPath", () => $ae872a3a7edb7f6b$export$1b227894fc2d04d0);
// Helper i18n minimale condiviso dai tool (CV Builder, interesse composto, ...).
// Le chiavi sono le stringhe italiane originali: una voce mancante nel dizionario
// degrada in italiano invece di rompere la UI.
//
// Uso:
//   import { t, PAGE_LANG, UI_LOCALE, langPath, registerTranslations } from './i18n.js';
//   registerTranslations(MY_EN_DICT); // una volta, all'init del modulo
//   t('Annulla')                        -> 'Cancel' su pagine EN, 'Annulla' su pagine IT
//   t('Mancano {n} immagini', { n: 3 }) -> interpolazione {placeholder} in entrambe le lingue
const $ae872a3a7edb7f6b$var$docLang = typeof document !== 'undefined' && document.documentElement?.lang || '';
const $ae872a3a7edb7f6b$var$pathIsEn = typeof location !== 'undefined' && (location.pathname === '/en' || location.pathname.startsWith('/en/'));
const $ae872a3a7edb7f6b$export$115162aea5a8ed44 = $ae872a3a7edb7f6b$var$docLang.toLowerCase().startsWith('en') || !$ae872a3a7edb7f6b$var$docLang && $ae872a3a7edb7f6b$var$pathIsEn ? 'en' : 'it';
const $ae872a3a7edb7f6b$export$7d2f96c91533b722 = $ae872a3a7edb7f6b$export$115162aea5a8ed44 === 'en' ? 'en-GB' : 'it-IT';
const $ae872a3a7edb7f6b$var$EN_DICT = {};
function $ae872a3a7edb7f6b$export$595d4929f5276beb(map) {
    if (map && typeof map === 'object') Object.assign($ae872a3a7edb7f6b$var$EN_DICT, map);
}
function $ae872a3a7edb7f6b$export$625550452a3fa3ec(str, vars) {
    let out = $ae872a3a7edb7f6b$export$115162aea5a8ed44 === 'en' ? $ae872a3a7edb7f6b$var$EN_DICT[str] ?? str : str;
    if (vars) out = out.replace(/\{(\w+)\}/g, (match, key)=>key in vars ? String(vars[key]) : match);
    return out;
}
function $ae872a3a7edb7f6b$export$1b227894fc2d04d0(path) {
    return $ae872a3a7edb7f6b$export$115162aea5a8ed44 === 'en' ? `/en${path}` : path;
}

});

parcelRegister("iXJZl", function(module, exports) {
module.exports = import.meta.resolve("htTIc");

});

// Dizionario prima degli altri moduli locali: si auto-registra su i18n.js.

var $eZ0we = parcelRequire("eZ0we");
parcelRequire("jhjrM");

var $lUp03 = parcelRequire("lUp03");

var $ilpIi = parcelRequire("ilpIi");

var $2hm3L = parcelRequire("2hm3L");

var $j1W2m = parcelRequire("j1W2m");

var $bNiyY = parcelRequire("bNiyY");

$j1W2m.GlobalWorkerOptions.workerSrc = new URL((parcelRequire("iXJZl"))).toString();
const $1c7b19a56ab2d0f4$var$LEGACY_STORAGE_KEY = 'cv_builder_draft_v2';
const $1c7b19a56ab2d0f4$var$STORAGE_KEY = 'cv_builder_workspace_v3';
const $1c7b19a56ab2d0f4$var$PENDING_ZIP_STORAGE_KEY = 'cv_builder_pending_import_zip';
const $1c7b19a56ab2d0f4$var$WORKSPACE_SCHEMA_VERSION = 3;
const $1c7b19a56ab2d0f4$var$STORAGE_DB_NAME = 'cv_builder_db';
const $1c7b19a56ab2d0f4$var$STORAGE_STORE_NAME = 'drafts';
const $1c7b19a56ab2d0f4$var$editorUrl = (0, $eZ0we.langPath)('/cv-builder/editor/');
const $1c7b19a56ab2d0f4$var$startButton = document.querySelector('#cv-start');
const $1c7b19a56ab2d0f4$var$resumeButton = document.querySelector('#cv-resume');
const $1c7b19a56ab2d0f4$var$importButton = document.querySelector('#cv-import');
const $1c7b19a56ab2d0f4$var$importInput = document.querySelector('#cv-import-file');
// Tutti i pulsanti «inizia» della pagina, non solo il primo: con querySelector
// quelli dopo il primo (la chiamata finale in fondo alla landing) non facevano
// niente.
const $1c7b19a56ab2d0f4$var$ctaStarts = Array.from(document.querySelectorAll('[data-action="cta-start"]'));
const $1c7b19a56ab2d0f4$var$previewTemplateButtons = Array.from(document.querySelectorAll('.cv-preview-cta'));
const $1c7b19a56ab2d0f4$var$ctaImport = document.querySelector('[data-action="cta-import"]');
const $1c7b19a56ab2d0f4$var$ctaResume = document.querySelector('[data-action="cta-resume"]');
const $1c7b19a56ab2d0f4$var$importPdfBtn = document.querySelector('#cv-import-pdf-btn');
const $1c7b19a56ab2d0f4$var$importPdfInput = document.querySelector('#cv-import-pdf-file');
const $1c7b19a56ab2d0f4$var$ctaImportPdf = document.querySelector('[data-action="cta-import-pdf"]');
const $1c7b19a56ab2d0f4$var$downloadCountEls = Array.from(document.querySelectorAll('[data-download-count]'));
const $1c7b19a56ab2d0f4$var$downloadMetricEls = Array.from(document.querySelectorAll('[data-downloads-section]'));
const $1c7b19a56ab2d0f4$var$downloadsSections = Array.from(document.querySelectorAll('[data-downloads-section]'));
function $1c7b19a56ab2d0f4$var$getCvBuilderDownloadStatsDocId(baseUrl) {
    const normalizedBaseUrl = String(baseUrl || '').trim();
    if (!normalizedBaseUrl) return '';
    return `cvBuilderPdfDownloads_${encodeURIComponent(normalizedBaseUrl)}`;
}
function $1c7b19a56ab2d0f4$var$hideDownloadMetrics() {
    $1c7b19a56ab2d0f4$var$downloadMetricEls.forEach((el)=>{
        el.hidden = true;
    });
}
function $1c7b19a56ab2d0f4$var$setDownloadMetricsBusy(isBusy) {
    $1c7b19a56ab2d0f4$var$downloadMetricEls.forEach((el)=>{
        el.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    });
}
// IndexedDB helpers
let $1c7b19a56ab2d0f4$var$dbInstance = null;
async function $1c7b19a56ab2d0f4$var$openDatabase() {
    return new Promise((resolve, reject)=>{
        if ($1c7b19a56ab2d0f4$var$dbInstance) {
            resolve($1c7b19a56ab2d0f4$var$dbInstance);
            return;
        }
        const request = indexedDB.open($1c7b19a56ab2d0f4$var$STORAGE_DB_NAME, 1);
        request.onerror = ()=>reject(request.error);
        request.onsuccess = ()=>{
            $1c7b19a56ab2d0f4$var$dbInstance = request.result;
            resolve($1c7b19a56ab2d0f4$var$dbInstance);
        };
        request.onupgradeneeded = (event)=>{
            const db = event.target.result;
            if (!db.objectStoreNames.contains($1c7b19a56ab2d0f4$var$STORAGE_STORE_NAME)) db.createObjectStore($1c7b19a56ab2d0f4$var$STORAGE_STORE_NAME, {
                keyPath: 'id'
            });
        };
    });
}
async function $1c7b19a56ab2d0f4$var$loadFromIndexedDB(key) {
    try {
        const db = await $1c7b19a56ab2d0f4$var$openDatabase();
        return new Promise((resolve)=>{
            const transaction = db.transaction([
                $1c7b19a56ab2d0f4$var$STORAGE_STORE_NAME
            ], 'readonly');
            const store = transaction.objectStore($1c7b19a56ab2d0f4$var$STORAGE_STORE_NAME);
            const request = store.get(key);
            request.onsuccess = ()=>resolve(request.result?.data || null);
            request.onerror = ()=>resolve(null);
        });
    } catch  {
        return null;
    }
}
async function $1c7b19a56ab2d0f4$var$saveToIndexedDB(key, data) {
    try {
        const db = await $1c7b19a56ab2d0f4$var$openDatabase();
        return new Promise((resolve)=>{
            const transaction = db.transaction([
                $1c7b19a56ab2d0f4$var$STORAGE_STORE_NAME
            ], 'readwrite');
            const store = transaction.objectStore($1c7b19a56ab2d0f4$var$STORAGE_STORE_NAME);
            store.put({
                id: key,
                data: data,
                updatedAt: Date.now()
            });
            transaction.oncomplete = ()=>resolve(true);
            transaction.onerror = ()=>resolve(false);
        });
    } catch  {
        return false;
    }
}
async function $1c7b19a56ab2d0f4$var$deleteFromIndexedDB(key) {
    try {
        const db = await $1c7b19a56ab2d0f4$var$openDatabase();
        return new Promise((resolve)=>{
            const transaction = db.transaction([
                $1c7b19a56ab2d0f4$var$STORAGE_STORE_NAME
            ], 'readwrite');
            const store = transaction.objectStore($1c7b19a56ab2d0f4$var$STORAGE_STORE_NAME);
            store.delete(key);
            transaction.oncomplete = ()=>resolve(true);
            transaction.onerror = ()=>resolve(false);
        });
    } catch  {
        return false;
    }
}
function $1c7b19a56ab2d0f4$var$createCvId(prefix = 'cv') {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}
function $1c7b19a56ab2d0f4$var$inferCvName(cv, fallback = (0, $eZ0we.t)('CV principale')) {
    const fullName = typeof cv?.profile?.fullName === 'string' ? cv.profile.fullName.trim() : '';
    return fullName ? `CV ${fullName}` : fallback;
}
function $1c7b19a56ab2d0f4$var$isStoredWorkspace(data) {
    return Boolean(data && typeof data === 'object' && Array.isArray(data.cvs) && data.cvs.length > 0);
}
function $1c7b19a56ab2d0f4$var$wrapSingleCvAsWorkspace(cv, { name: name = '', source: source = 'legacy-json' } = {}) {
    const id = $1c7b19a56ab2d0f4$var$createCvId();
    const now = new Date().toISOString();
    return {
        schemaVersion: $1c7b19a56ab2d0f4$var$WORKSPACE_SCHEMA_VERSION,
        activeCvId: id,
        cvs: [
            {
                id: id,
                name: name || $1c7b19a56ab2d0f4$var$inferCvName(cv, (0, $eZ0we.t)('CV importato')),
                createdAt: now,
                updatedAt: now,
                source: source,
                cv: cv,
                coachTipsDelivered: 0,
                coachActiveTipId: '',
                coachViewedTipIds: []
            }
        ]
    };
}
function $1c7b19a56ab2d0f4$var$setButtonLabel(button, label) {
    if (!button) return;
    const labelEl = button.querySelector('.button-text');
    if (labelEl) {
        labelEl.textContent = label;
        return;
    }
    button.textContent = label;
}
async function $1c7b19a56ab2d0f4$var$hasDraft() {
    const workspace = await $1c7b19a56ab2d0f4$var$loadFromIndexedDB($1c7b19a56ab2d0f4$var$STORAGE_KEY);
    if ($1c7b19a56ab2d0f4$var$isStoredWorkspace(workspace)) return true;
    const legacy = await $1c7b19a56ab2d0f4$var$loadFromIndexedDB($1c7b19a56ab2d0f4$var$LEGACY_STORAGE_KEY);
    if (legacy && typeof legacy === 'object') return true;
    try {
        const raw = localStorage.getItem($1c7b19a56ab2d0f4$var$LEGACY_STORAGE_KEY);
        if (!raw) return false;
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object';
    } catch  {
        return false;
    }
}
function $1c7b19a56ab2d0f4$var$goToEditor() {
    window.location.href = $1c7b19a56ab2d0f4$var$editorUrl;
}
function $1c7b19a56ab2d0f4$var$openImportDialog() {
    if ($1c7b19a56ab2d0f4$var$importInput) $1c7b19a56ab2d0f4$var$importInput.click();
}
async function $1c7b19a56ab2d0f4$var$applyDraftState() {
    const draftAvailable = await $1c7b19a56ab2d0f4$var$hasDraft();
    if (draftAvailable) {
        if ($1c7b19a56ab2d0f4$var$resumeButton) $1c7b19a56ab2d0f4$var$resumeButton.classList.remove('is-hidden');
        if ($1c7b19a56ab2d0f4$var$startButton) {
            $1c7b19a56ab2d0f4$var$setButtonLabel($1c7b19a56ab2d0f4$var$startButton, (0, $eZ0we.t)('Parti da zero'));
            $1c7b19a56ab2d0f4$var$startButton.dataset.reset = 'true';
        }
        if ($1c7b19a56ab2d0f4$var$resumeButton) $1c7b19a56ab2d0f4$var$setButtonLabel($1c7b19a56ab2d0f4$var$resumeButton, (0, $eZ0we.t)('Continua da dove avevi lasciato'));
        if ($1c7b19a56ab2d0f4$var$importButton) $1c7b19a56ab2d0f4$var$setButtonLabel($1c7b19a56ab2d0f4$var$importButton, (0, $eZ0we.t)('Importa backup'));
        if ($1c7b19a56ab2d0f4$var$ctaResume) {
            $1c7b19a56ab2d0f4$var$ctaResume.classList.remove('is-hidden');
            $1c7b19a56ab2d0f4$var$setButtonLabel($1c7b19a56ab2d0f4$var$ctaResume, (0, $eZ0we.t)('Continua da dove avevi lasciato'));
        }
        if ($1c7b19a56ab2d0f4$var$ctaImport) $1c7b19a56ab2d0f4$var$setButtonLabel($1c7b19a56ab2d0f4$var$ctaImport, (0, $eZ0we.t)('Importa backup'));
    }
}
async function $1c7b19a56ab2d0f4$var$clearStoredWorkspace() {
    await $1c7b19a56ab2d0f4$var$deleteFromIndexedDB($1c7b19a56ab2d0f4$var$STORAGE_KEY);
    await $1c7b19a56ab2d0f4$var$deleteFromIndexedDB($1c7b19a56ab2d0f4$var$PENDING_ZIP_STORAGE_KEY);
    await $1c7b19a56ab2d0f4$var$deleteFromIndexedDB($1c7b19a56ab2d0f4$var$LEGACY_STORAGE_KEY);
    try {
        localStorage.removeItem($1c7b19a56ab2d0f4$var$LEGACY_STORAGE_KEY);
    } catch  {
    // ignore
    }
}
async function $1c7b19a56ab2d0f4$var$handleStartClick() {
    if ($1c7b19a56ab2d0f4$var$startButton?.dataset.reset === 'true') try {
        await $1c7b19a56ab2d0f4$var$clearStoredWorkspace();
    } catch (error) {
        console.warn('Impossibile rimuovere il workspace salvato', error);
    }
    $1c7b19a56ab2d0f4$var$goToEditor();
}
async function $1c7b19a56ab2d0f4$var$handleImportFile(event) {
    const file = event.target.files?.[0];
    if (!file) return;
    try {
        if (/\.zip$/i.test(file.name) || file.type.includes('zip')) {
            const zip = await (0, (/*@__PURE__*/$parcel$interopDefault($lUp03))).loadAsync(file);
            const workspaceEntry = zip.file('workspace.json');
            if (!workspaceEntry) throw new Error('workspace.json mancante');
            const workspace = JSON.parse(await workspaceEntry.async('string'));
            if (!$1c7b19a56ab2d0f4$var$isStoredWorkspace(workspace)) throw new Error('Formato workspace non valido');
            await $1c7b19a56ab2d0f4$var$saveToIndexedDB($1c7b19a56ab2d0f4$var$STORAGE_KEY, workspace);
            await $1c7b19a56ab2d0f4$var$saveToIndexedDB($1c7b19a56ab2d0f4$var$PENDING_ZIP_STORAGE_KEY, await file.arrayBuffer());
        } else {
            const parsed = JSON.parse(await file.text());
            if (!parsed || typeof parsed !== 'object') throw new Error('Formato non valido');
            const workspace = $1c7b19a56ab2d0f4$var$isStoredWorkspace(parsed) ? parsed : $1c7b19a56ab2d0f4$var$wrapSingleCvAsWorkspace(parsed);
            await $1c7b19a56ab2d0f4$var$saveToIndexedDB($1c7b19a56ab2d0f4$var$STORAGE_KEY, workspace);
        }
        $1c7b19a56ab2d0f4$var$goToEditor();
    } catch (error) {
        console.error('Import fallito', error);
        alert((0, $eZ0we.t)("Il file selezionato non \xe8 un backup valido."));
    } finally{
        event.target.value = '';
    }
}
// Initialize
$1c7b19a56ab2d0f4$var$applyDraftState();
$1c7b19a56ab2d0f4$var$startButton?.addEventListener('click', $1c7b19a56ab2d0f4$var$handleStartClick);
$1c7b19a56ab2d0f4$var$resumeButton?.addEventListener('click', $1c7b19a56ab2d0f4$var$goToEditor);
$1c7b19a56ab2d0f4$var$importButton?.addEventListener('click', $1c7b19a56ab2d0f4$var$openImportDialog);
// Solo «Parti da zero» (#cv-start) svuota il workspace salvato, e lo dice
// nell'etichetta. Le altre chiamate all'azione passavano dallo stesso gestore: a
// chi tornava con dei CV salvati, un clic su «Prova gratis» o «Create your CV» li
// cancellava tutti senza chiedere, e senza Premium erano solo sul dispositivo.
// Ora aprono l'editor, dove il workspace c'e' gia' e un CV nuovo si aggiunge
// agli altri.
$1c7b19a56ab2d0f4$var$ctaStarts.forEach((button)=>button.addEventListener('click', $1c7b19a56ab2d0f4$var$goToEditor));
$1c7b19a56ab2d0f4$var$previewTemplateButtons.forEach((button)=>button.addEventListener('click', $1c7b19a56ab2d0f4$var$goToEditor));
$1c7b19a56ab2d0f4$var$ctaImport?.addEventListener('click', $1c7b19a56ab2d0f4$var$openImportDialog);
$1c7b19a56ab2d0f4$var$ctaResume?.addEventListener('click', $1c7b19a56ab2d0f4$var$goToEditor);
$1c7b19a56ab2d0f4$var$importInput?.addEventListener('change', $1c7b19a56ab2d0f4$var$handleImportFile);
// --- PDF Import from Landing ---
const $1c7b19a56ab2d0f4$var$PARSE_CV_TIMEOUT_MS = 45000;
function $1c7b19a56ab2d0f4$var$showLandingPdfConfirmDialog() {
    return new Promise((resolve)=>{
        const overlay = document.createElement('div');
        overlay.style.cssText = 'position:fixed;inset:0;display:flex;align-items:center;justify-content:center;z-index:80;';
        overlay.innerHTML = `
      <div style="position:absolute;inset:0;background:rgba(15,23,42,0.5);" data-action="cancel"></div>
      <div style="position:relative;background:#fff;border-radius:14px;padding:1.5rem;width:min(520px,92vw);box-shadow:0 10px 40px rgba(0,0,0,0.15);z-index:1;display:flex;flex-direction:column;gap:1rem;">
        <h3 style="margin:0;font-size:1.1rem;">${(0, $eZ0we.t)('Importa da PDF')}</h3>
        <p style="margin:0;font-size:0.95rem;color:#475569;">${(0, $eZ0we.t)("Per estrarre le informazioni dal tuo CV, il testo verr\xe0 inviato a Google (Gemini) per l'analisi. Nessun dato verr\xe0 memorizzato sui sistemi di Stipendee.")}</p>
        <div style="display:flex;flex-direction:column;gap:0.6rem;">
          <button type="button" class="myButton" data-action="confirm">${(0, $eZ0we.t)('Continua')}</button>
          <button type="button" class="myButton white-button" data-action="cancel">${(0, $eZ0we.t)('Annulla')}</button>
        </div>
      </div>
    `;
        document.body.appendChild(overlay);
        function cleanup(result) {
            overlay.remove();
            resolve(result);
        }
        overlay.querySelectorAll('[data-action="confirm"]').forEach((el)=>el.addEventListener('click', ()=>cleanup(true)));
        overlay.querySelectorAll('[data-action="cancel"]').forEach((el)=>el.addEventListener('click', ()=>cleanup(false)));
    });
}
function $1c7b19a56ab2d0f4$var$withTimeout(promise, timeoutMs, timeoutMessage) {
    let timeoutId = null;
    const timeoutPromise = new Promise((_, reject)=>{
        timeoutId = window.setTimeout(()=>reject(new Error(timeoutMessage)), timeoutMs);
    });
    return Promise.race([
        promise,
        timeoutPromise
    ]).finally(()=>{
        if (timeoutId) window.clearTimeout(timeoutId);
    });
}
function $1c7b19a56ab2d0f4$var$openPdfImportDialog() {
    if ($1c7b19a56ab2d0f4$var$importPdfInput) $1c7b19a56ab2d0f4$var$importPdfInput.click();
}
async function $1c7b19a56ab2d0f4$var$handleImportPdfFromLanding(event) {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;
    const confirmed = await $1c7b19a56ab2d0f4$var$showLandingPdfConfirmDialog();
    if (!confirmed) return;
    const stepper = (0, $bNiyY.createPdfImportStepper)();
    stepper.open();
    try {
        // Extract text from PDF
        const buffer = await file.arrayBuffer();
        const pdf = await $j1W2m.getDocument({
            data: buffer
        }).promise;
        const pages = [];
        for(let i = 1; i <= pdf.numPages; i++){
            const page = await pdf.getPage(i);
            const content = await page.getTextContent();
            pages.push(content.items.map((item)=>item.str).join(' '));
        }
        const pdfText = pages.join('\n').trim();
        if (!pdfText || pdfText.length < 20) {
            stepper.fail((0, $eZ0we.t)("Non \xe8 stato possibile leggere il testo dal PDF. Prova con un PDF diverso."));
            return;
        }
        // Get Firebase functions instance
        const initFn = window.firebaseInit;
        if (typeof initFn !== 'function') {
            stepper.fail((0, $eZ0we.t)("Qualcosa \xe8 andato storto. Riprova."));
            return;
        }
        const { app: app } = initFn();
        const functions = (0, $2hm3L.getFunctions)(app);
        const parseCvFromText = (0, $2hm3L.httpsCallable)(functions, 'parseCvFromText');
        const result = await $1c7b19a56ab2d0f4$var$withTimeout(parseCvFromText({
            text: pdfText,
            uiLang: (0, $eZ0we.PAGE_LANG)
        }), $1c7b19a56ab2d0f4$var$PARSE_CV_TIMEOUT_MS, 'timeout');
        const parsed = result?.data;
        if (!parsed || typeof parsed !== 'object') {
            stepper.fail((0, $eZ0we.t)("Qualcosa \xe8 andato storto. Riprova."));
            return;
        }
        // parseCvFromText non restituisce un locale: dalla landing EN i CV importati nascono en-GB.
        if ((0, $eZ0we.PAGE_LANG) === 'en' && !parsed.locale) parsed.locale = 'en-GB';
        const workspace = $1c7b19a56ab2d0f4$var$wrapSingleCvAsWorkspace(parsed, {
            name: $1c7b19a56ab2d0f4$var$inferCvName(parsed, (0, $eZ0we.t)('CV da PDF')),
            source: 'pdf-import'
        });
        await $1c7b19a56ab2d0f4$var$saveToIndexedDB($1c7b19a56ab2d0f4$var$STORAGE_KEY, workspace);
        stepper.complete();
        window.setTimeout(()=>$1c7b19a56ab2d0f4$var$goToEditor(), 900);
    } catch (error) {
        console.error('Import PDF fallito', error);
        const rawCode = typeof error?.code === 'string' ? error.code : '';
        const errorCode = rawCode.startsWith('functions/') ? rawCode.slice(10) : rawCode;
        const errorMsg = error?.message || '';
        if (errorMsg === 'timeout' || errorCode === 'deadline-exceeded') stepper.fail((0, $eZ0we.t)('La richiesta ha impiegato troppo tempo. Riprova.'));
        else if (errorCode === 'resource-exhausted') stepper.fail((0, $eZ0we.t)('Troppe richieste. Riprova tra qualche minuto.'));
        else stepper.fail((0, $eZ0we.t)("Qualcosa \xe8 andato storto. Riprova."));
    }
}
$1c7b19a56ab2d0f4$var$importPdfBtn?.addEventListener('click', $1c7b19a56ab2d0f4$var$openPdfImportDialog);
$1c7b19a56ab2d0f4$var$ctaImportPdf?.addEventListener('click', $1c7b19a56ab2d0f4$var$openPdfImportDialog);
$1c7b19a56ab2d0f4$var$importPdfInput?.addEventListener('change', $1c7b19a56ab2d0f4$var$handleImportPdfFromLanding);
function $1c7b19a56ab2d0f4$var$initHowCarousels() {
    const carousels = document.querySelectorAll('[data-how-carousel]');
    carousels.forEach((carousel)=>{
        const track = carousel.querySelector('[data-how-carousel-track]');
        const slides = Array.from(carousel.querySelectorAll('[data-how-carousel-slide]')).filter((slide)=>slide instanceof HTMLElement);
        const prevButton = carousel.querySelector('[data-how-carousel-prev]');
        const nextButton = carousel.querySelector('[data-how-carousel-next]');
        const dotsContainer = carousel.parentElement?.querySelector('[data-how-carousel-dots]');
        if (!(track instanceof HTMLElement) || !slides.length) return;
        const dots = dotsContainer ? slides.map((_, index)=>{
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'cv-how-carousel-dot';
            dot.setAttribute('aria-label', (0, $eZ0we.t)('Vai allo screenshot {n}', {
                n: index + 1
            }));
            dot.addEventListener('click', ()=>scrollToSlide(index));
            dotsContainer.appendChild(dot);
            return dot;
        }) : [];
        function getCurrentIndex() {
            return slides.reduce((closestIndex, slide, index)=>{
                const currentDistance = Math.abs(slide.offsetLeft - track.scrollLeft);
                const closestDistance = Math.abs(slides[closestIndex].offsetLeft - track.scrollLeft);
                return currentDistance < closestDistance ? index : closestIndex;
            }, 0);
        }
        function updateViewportHeight() {
            const slide = slides[getCurrentIndex()];
            if (!slide) return;
            track.style.height = `${slide.offsetHeight}px`;
        }
        // Cambiare l'altezza del track a metà swipe causa un reflow che interrompe lo
        // scroll snap (si resta fermi tra due slide): l'altezza va aggiornata solo quando
        // lo scroll si è assestato, cioè ~150ms dopo l'ultimo evento di scroll.
        let heightSettleTimer = null;
        function scheduleViewportHeightUpdate() {
            window.clearTimeout(heightSettleTimer);
            heightSettleTimer = window.setTimeout(updateViewportHeight, 150);
        }
        function scrollToSlide(index) {
            const slide = slides[Math.max(0, Math.min(index, slides.length - 1))];
            track.scrollTo({
                left: slide.offsetLeft,
                behavior: 'smooth'
            });
        }
        let lastActiveIndex = -1;
        function updateControls() {
            const activeIndex = getCurrentIndex();
            if (prevButton instanceof HTMLButtonElement) prevButton.disabled = activeIndex === 0;
            if (nextButton instanceof HTMLButtonElement) nextButton.disabled = activeIndex === slides.length - 1;
            dots.forEach((dot, index)=>{
                const isActive = index === activeIndex;
                dot.classList.toggle('is-active', isActive);
                dot.setAttribute('aria-current', isActive ? 'true' : 'false');
            });
            if (activeIndex !== lastActiveIndex) lastActiveIndex = activeIndex;
        }
        let frameId = null;
        function requestControlsUpdate() {
            if (frameId) window.cancelAnimationFrame(frameId);
            frameId = window.requestAnimationFrame(updateControls);
        }
        prevButton?.addEventListener('click', ()=>scrollToSlide(getCurrentIndex() - 1));
        nextButton?.addEventListener('click', ()=>scrollToSlide(getCurrentIndex() + 1));
        track.addEventListener('scroll', ()=>{
            requestControlsUpdate();
            scheduleViewportHeightUpdate();
        }, {
            passive: true
        });
        track.addEventListener('keydown', (event)=>{
            if (event.key === 'ArrowLeft') {
                event.preventDefault();
                scrollToSlide(getCurrentIndex() - 1);
            }
            if (event.key === 'ArrowRight') {
                event.preventDefault();
                scrollToSlide(getCurrentIndex() + 1);
            }
        });
        window.addEventListener('resize', ()=>{
            requestControlsUpdate();
            scheduleViewportHeightUpdate();
        });
        slides.forEach((slide)=>{
            slide.querySelectorAll('img').forEach((img)=>{
                if (img.complete) return;
                img.addEventListener('load', scheduleViewportHeightUpdate, {
                    once: true
                });
            });
        });
        if (typeof ResizeObserver !== 'undefined') {
            const resizeObserver = new ResizeObserver(()=>scheduleViewportHeightUpdate());
            slides.forEach((slide)=>resizeObserver.observe(slide));
        }
        updateControls();
        updateViewportHeight();
    });
}
$1c7b19a56ab2d0f4$var$initHowCarousels();
// Il carosello dell'hero: le anteprime dei modelli in dissolvenza, senza
// scritte ne' comandi. Avanza da solo ogni INTERVALLO, ma si ferma col mouse
// sopra, quando non si vede (fuori schermo, scheda in secondo piano, o la copia
// per telefono su desktop) e per chi chiede meno movimento, che vede la prima
// anteprima ferma. La prima anteprima e' nell'HTML, le altre sono nascoste e
// si caricano una alla volta prima di comparire.
function $1c7b19a56ab2d0f4$var$initHeroCaroselli() {
    const INTERVALLO = 3500;
    const menoMovimento = window.matchMedia('(prefers-reduced-motion: reduce)');
    document.querySelectorAll('[data-hero-carosello]').forEach((carosello)=>{
        const foto = Array.from(carosello.querySelectorAll('.cv-hero-carosello-foto'));
        if (foto.length < 2) return;
        let attiva = 0;
        let timer = null;
        let sopra = false;
        let visibile = false;
        const prepara = (indice)=>{
            const img = foto[indice];
            img.hidden = false;
            return img.decode().catch(()=>{});
        };
        const mostra = async (indice)=>{
            await prepara(indice);
            foto.forEach((img, n)=>{
                img.classList.toggle('is-attiva', n === indice);
                img.setAttribute('aria-hidden', n === indice ? 'false' : 'true');
            });
            attiva = indice;
            // La prossima si carica mentre questa resta a schermo.
            prepara((indice + 1) % foto.length);
        };
        const ferma = ()=>{
            clearTimeout(timer);
            timer = null;
        };
        const programma = ()=>{
            ferma();
            if (menoMovimento.matches || sopra || !visibile || document.hidden) return;
            timer = setTimeout(async ()=>{
                await mostra((attiva + 1) % foto.length);
                programma();
            }, INTERVALLO);
        };
        carosello.addEventListener('mouseenter', ()=>{
            sopra = true;
            ferma();
        });
        carosello.addEventListener('mouseleave', ()=>{
            sopra = false;
            programma();
        });
        document.addEventListener('visibilitychange', programma);
        menoMovimento.addEventListener?.('change', programma);
        if ('IntersectionObserver' in window) new IntersectionObserver(([voce])=>{
            visibile = voce.isIntersecting;
            programma();
        }, {
            threshold: 0.3
        }).observe(carosello);
        else {
            visibile = true;
            programma();
        }
    });
}
$1c7b19a56ab2d0f4$var$initHeroCaroselli();
const $1c7b19a56ab2d0f4$var$zoomModal = document.getElementById('cv-zoom-modal');
const $1c7b19a56ab2d0f4$var$zoomImage = $1c7b19a56ab2d0f4$var$zoomModal?.querySelector('.cv-zoom-image');
const $1c7b19a56ab2d0f4$var$zoomTriggers = document.querySelectorAll('[data-zoom-trigger]');
let $1c7b19a56ab2d0f4$var$lastZoomFocus = null;
function $1c7b19a56ab2d0f4$var$openZoomModal(trigger) {
    if (!$1c7b19a56ab2d0f4$var$zoomModal || !$1c7b19a56ab2d0f4$var$zoomImage) return;
    const img = trigger.querySelector('img');
    if (!img) return;
    $1c7b19a56ab2d0f4$var$zoomImage.src = img.currentSrc || img.src;
    $1c7b19a56ab2d0f4$var$zoomImage.alt = img.alt || (0, $eZ0we.t)('Anteprima CV');
    $1c7b19a56ab2d0f4$var$zoomModal.classList.add('is-open');
    $1c7b19a56ab2d0f4$var$zoomModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cv-zoom-open');
    $1c7b19a56ab2d0f4$var$lastZoomFocus = document.activeElement;
    const closeButton = $1c7b19a56ab2d0f4$var$zoomModal.querySelector('[data-zoom-action="close"]');
    if (closeButton instanceof HTMLElement) closeButton.focus();
}
function $1c7b19a56ab2d0f4$var$closeZoomModal() {
    if (!$1c7b19a56ab2d0f4$var$zoomModal || !$1c7b19a56ab2d0f4$var$zoomImage) return;
    $1c7b19a56ab2d0f4$var$zoomModal.classList.remove('is-open');
    $1c7b19a56ab2d0f4$var$zoomModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cv-zoom-open');
    $1c7b19a56ab2d0f4$var$zoomImage.src = '';
    $1c7b19a56ab2d0f4$var$zoomImage.alt = '';
    if ($1c7b19a56ab2d0f4$var$lastZoomFocus instanceof HTMLElement) $1c7b19a56ab2d0f4$var$lastZoomFocus.focus();
    $1c7b19a56ab2d0f4$var$lastZoomFocus = null;
}
const $1c7b19a56ab2d0f4$var$isMobileZoomDisabled = ()=>window.matchMedia('(max-width: 768px)').matches;
$1c7b19a56ab2d0f4$var$zoomTriggers.forEach((trigger)=>{
    trigger.addEventListener('click', ()=>{
        if ($1c7b19a56ab2d0f4$var$isMobileZoomDisabled()) return;
        $1c7b19a56ab2d0f4$var$openZoomModal(trigger);
    });
});
function $1c7b19a56ab2d0f4$var$formatDownloadCount(value) {
    const abs = Math.abs(value);
    if (abs >= 1000000) return `${$1c7b19a56ab2d0f4$var$trimDecimal(value / 1000000)}M`;
    if (abs >= 1000) return `${$1c7b19a56ab2d0f4$var$trimDecimal(value / 1000)}k`;
    return Math.round(value).toString();
}
function $1c7b19a56ab2d0f4$var$trimDecimal(value) {
    const rounded = Math.round(value * 10) / 10;
    const text = rounded.toFixed(1);
    return text.endsWith('.0') ? text.slice(0, -2) : text;
}
function $1c7b19a56ab2d0f4$var$animateDownloadCount(target) {
    if (!$1c7b19a56ab2d0f4$var$downloadCountEls.length) return;
    if (target <= 0) {
        $1c7b19a56ab2d0f4$var$hideDownloadMetrics();
        return;
    }
    const duration = 1400;
    const startTime = performance.now();
    const startValue = 0;
    function tick(now) {
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = Math.round(startValue + (target - startValue) * eased);
        const formatted = $1c7b19a56ab2d0f4$var$formatDownloadCount(current);
        $1c7b19a56ab2d0f4$var$downloadCountEls.forEach((el)=>{
            el.textContent = formatted;
        });
        if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
}
async function $1c7b19a56ab2d0f4$var$loadDownloadCount() {
    if (!$1c7b19a56ab2d0f4$var$downloadCountEls.length) return 0;
    $1c7b19a56ab2d0f4$var$setDownloadMetricsBusy(true);
    try {
        const initFn = window.firebaseInit;
        if (typeof initFn !== 'function') throw new Error('firebaseInit non disponibile');
        const { app: app } = initFn();
        const db = (0, $ilpIi.getFirestore)(app);
        const statsDocId = $1c7b19a56ab2d0f4$var$getCvBuilderDownloadStatsDocId(window.location.origin);
        if (!statsDocId) throw new Error('Base URL non disponibile');
        const snapshot = await (0, $ilpIi.getDoc)((0, $ilpIi.doc)(db, 'publicStats', statsDocId));
        const total = Number(snapshot.data()?.total || 0);
        $1c7b19a56ab2d0f4$var$setDownloadMetricsBusy(false);
        if (total <= 0) {
            $1c7b19a56ab2d0f4$var$hideDownloadMetrics();
            return 0;
        }
        $1c7b19a56ab2d0f4$var$downloadCountEls.forEach((el)=>{
            el.dataset.target = String(total);
        });
        return total;
    } catch (error) {
        console.warn('Conteggio download CV non disponibile', error);
        $1c7b19a56ab2d0f4$var$setDownloadMetricsBusy(false);
        $1c7b19a56ab2d0f4$var$hideDownloadMetrics();
        return 0;
    }
}
async function $1c7b19a56ab2d0f4$var$initDownloadCount() {
    if (!$1c7b19a56ab2d0f4$var$downloadCountEls.length || !$1c7b19a56ab2d0f4$var$downloadsSections.length) return;
    const total = await $1c7b19a56ab2d0f4$var$loadDownloadCount();
    if (total <= 0) return;
    let hasAnimated = false;
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting || hasAnimated) return;
            hasAnimated = true;
            $1c7b19a56ab2d0f4$var$animateDownloadCount(total);
            observer.disconnect();
        });
    }, {
        threshold: 0.35
    });
    $1c7b19a56ab2d0f4$var$downloadsSections.forEach((section)=>observer.observe(section));
}
$1c7b19a56ab2d0f4$var$initDownloadCount();
$1c7b19a56ab2d0f4$var$zoomModal?.addEventListener('click', (event)=>{
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    if (target.closest('[data-zoom-action="close"]')) $1c7b19a56ab2d0f4$var$closeZoomModal();
});
document.addEventListener('keydown', (event)=>{
    if (event.key !== 'Escape') return;
    if (!$1c7b19a56ab2d0f4$var$zoomModal?.classList.contains('is-open')) return;
    $1c7b19a56ab2d0f4$var$closeZoomModal();
});
// Evento GTM al primo play del video demo (il tag lato GTM lo configura il dashboard).
document.querySelectorAll('.cv-video-player').forEach((video)=>{
    video.addEventListener('play', ()=>{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'cv_video_play'
        });
    }, {
        once: true
    });
});


//# sourceMappingURL=cv-builder.0fd37d22.js.map
